import { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { FormParserContext } from 'src/contexts/form.context';
import { addInputAddedUser, addInputInvitedUser } from 'src/store/team/team.reducer';
import { InputContext } from 'src/contexts/input.context';
import { EmailAutoComplete } from 'src/components/InputRenderers';
import { InputAddUser, InputInviteUser } from 'src/models';
import { ifTrue } from 'src/tools/logic.tools';

export function EmailInput() {
  const { script, onChange, resource_id, resource_type, error } = useContext(FormParserContext);

  const dispatch = useDispatch();

  function handleOnAddInputInvitedUser(data: InputInviteUser) {
    dispatch(addInputInvitedUser(data));
  }

  function handleOnAddInputAddedUser(data: InputAddUser) {
    dispatch(addInputAddedUser(data));
  }

  return (
    <InputContext.Provider
      value={{
        classNames: { container: 'w-100p', input: ifTrue(error, 'with-error') },
        value: '',
        onChange,
        isDisabled: script.isDisabled,
        isAutoFocus: script.autofocus,
        placeholder: script.placeholder,
        customization: {
          resource_id,
          resource_type,
        },
        actions: {
          onAddInputInvitedUser: handleOnAddInputInvitedUser,
          onAddInputAddedUser: handleOnAddInputAddedUser,
        },
      }}
    >
      <EmailAutoComplete />
    </InputContext.Provider>
  );
}
